import { AxiosResponse } from 'axios';

import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessDeleteImages extends ResponseREST {
  data: Array<{ uuid: string; dataURL: string }>;
}

interface Body {
  uuid: Array<string>;
}

export const postDeleteImages = async (body: Body): Promise<ResponseSuccessDeleteImages> => {
  return axiosInstance
    .post('image/delete', body)
    .then((res: AxiosResponse<ResponseSuccessDeleteImages>) => res.data)
    .catch((err) => err);
};
